import { render, staticRenderFns } from "./ObjectFileList.vue?vue&type=template&id=637093a4&scoped=true&"
import script from "./ObjectFileList.vue?vue&type=script&lang=js&"
export * from "./ObjectFileList.vue?vue&type=script&lang=js&"
import style0 from "./ObjectFileList.vue?vue&type=style&index=0&id=637093a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637093a4",
  null
  
)

export default component.exports